import { render, staticRenderFns } from "./PaginationAlert.vue?vue&type=template&id=ef639b48&"
import script from "./PaginationAlert.vue?vue&type=script&lang=js&"
export * from "./PaginationAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../fodchef/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports